const plugins = [
  'preloader',
  'filters',
  'hammer',
  'lazyload',
  'meta',
  'modals',
  'veeValidate',
  'ym',
  'dspCounter',
  'fb'
]

plugins.forEach((file) => {
  require(`./${file}`)
})
